import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

Swiper.use([Pagination, Navigation, Autoplay, EffectFade]);

// @import "./node_modules/swiper/swiper";
// @import "./node_modules/swiper/modules/effect-fade/effect-fade";

// import 'swiper/swiper-bundle.css';

import { lazyLoadImages, lazyLoadVideos } from './functions.js';

const swiperSlider = (selector) => {
	const swiperSliders = document.querySelectorAll(selector);
	const prevArrows = document.querySelectorAll('.swiper-button-prev');
	const nextArrows = document.querySelectorAll('.swiper-button-next');

	swiperSliders.forEach((slider, i) => {
		const swiper = new Swiper(slider, {
			loop: true,
			spaceBetween: 0,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: nextArrows[i],
				prevEl: prevArrows[i],
			},
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
				},
			},
		});
	});
};
document.addEventListener('DOMContentLoaded', () => {
	swiperSlider('.swiper-slider-hero-text');
	swiperSlider('.swiper-slider-hero-image');
});

const swiperSliderSlider = (selector) => {
	const swiperSliders = document.querySelectorAll(selector);
	swiperSliders.forEach((slider, i) => {
		let nearestSlider = slider.closest('section');
		let prev = nearestSlider.querySelector('.swiper-button-prev');
		let next = nearestSlider.querySelector('.swiper-button-next');
		const dataSlideNumber = slider.getAttribute('data-slide-number');
		const totalSlides = slider.querySelectorAll('.swiper-slide').length;

		const swiper = new Swiper(slider, {
			loop: true,
			spaceBetween: 0,
			// speed: 1000,
			// autoplay: {
			// delay: 1750,
			// disableOnInteraction: true,
			// },
			navigation: {
				prevEl: prev,
				nextEl: next,
			},
			// modules: [Navigation, Autoplay],
			// slidesPerGroup: 1,
			// loopAddBlankSlides: true,
			breakpoints: {
				0: {
					slidesPerView: 1,
				},
				768: {
					slidesPerView: dataSlideNumber
						? parseInt(dataSlideNumber)
						: 1,
					// slidesPerView: 3,
				},
			},
		});
	});
};
// document.addEventListener('DOMContentLoaded', () => {
swiperSliderSlider('.swiper-slider-slider');
// });

const swiperSliderClients = (selector) => {
	const swiperSliders = document.querySelectorAll(selector);
	const prevArrows = document.querySelectorAll('.swiper-button-prev');
	const nextArrows = document.querySelectorAll('.swiper-button-next');

	swiperSliders.forEach((slider, i) => {
		const swiper = new Swiper(slider, {
			loop: true,
			spaceBetween: 20,
			speed: 1000,
			centerInsufficientSlides: true,
			autoplay: {
				delay: 1750,
				disableOnInteraction: false,
			},
			modules: [Autoplay],
			breakpoints: {
				0: {
					slidesPerView: 3,
				},
				768: {
					slidesPerView: 6,
				},
				1024: {
					slidesPerView: 8,
				},
			},
		});
	});
};
// document.addEventListener('DOMContentLoaded', () => {
swiperSliderClients('.swiper-slider-logos');
// });

const swiperSliderTestimonial = (selector) => {
	const swiperSliders = document.querySelectorAll(selector);
	swiperSliders.forEach((slider, i) => {
		let nearestSlider = slider.closest('section');
		let prev = nearestSlider.querySelector('.swiper-button-prev');
		let next = nearestSlider.querySelector('.swiper-button-next');
		let pagination = nearestSlider.querySelector('.swiper-pagination');

		// Calculate the number of slides
		let slidesCount = slider.querySelectorAll('.swiper-slide').length;

		const swiper = new Swiper(slider, {
			loop: true,
			spaceBetween: 100,
			speed: 1000,
			autoplay: {
				delay: 10000,
				disableOnInteraction: false,
			},
			navigation: {
				nextEl: prev,
				prevEl: next,
			},
			slidesPerView: 1,
			modules: [Autoplay, Pagination],
			pagination: {
				el: slidesCount > 1 ? pagination : null,
				clickable: true,
			},
		});
	});
};
// document.addEventListener('DOMContentLoaded', () => {
swiperSliderTestimonial('.swiper-slider-testimonial');
// });

const swiperSliderPosts = (selector) => {
	const swiperSliders = document.querySelectorAll(selector);
	const prevArrows = document.querySelectorAll('.swiper-button-prev');
	const nextArrows = document.querySelectorAll('.swiper-button-next');

	swiperSliders.forEach((slider, i) => {
		const swiper = new Swiper(slider, {
			loop: true,
			spaceBetween: 40,
			speed: 1500,
			navigation: {
				nextEl: nextArrows[i],
				prevEl: prevArrows[i],
			},
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			modules: [Autoplay, Navigation],
			breakpoints: {
				0: {
					slidesPerView: 1,
				},
				768: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
			},
		});
	});
};

// document.addEventListener('DOMContentLoaded', () => {
swiperSliderPosts('.swiper-slider-posts');
// });
